export class UtilsEnum {
  /**
   * @param {Object} definition
   * @returns {any}
   */
  static create(definition) {
    const enumObject = {};

    for (const [key, metadata] of Object.entries(definition)) {
      const { value, ...restMetadata } = metadata;

      const item = {
        toString: () => String(value),
        valueOf: () => value,

        getValue: () => value,
        ...Object.keys(restMetadata).reduce((acc, prop) => {
          const methodName = `get${prop.charAt(0).toUpperCase() + prop.slice(1)}`;
          acc[methodName] = () => restMetadata[prop];
          return acc;
        }, {}),
      };

      enumObject[key] = Object.freeze(item);
    }

    enumObject.get = (val) => {
      return (
        Object.values(enumObject).find((i) => typeof i !== 'function' && i.getValue() === val) || {}
      );
    };

    enumObject.values = () =>
      Object.values(enumObject)
        .filter((i) => typeof i !== 'function')
        .map((i) => i.getValue());

    enumObject.asItems = () => {
      return enumObject.values().map((val) => {
        const item = enumObject.get(val);

        // Tenta pegar Description, se não existir tenta Name, senão usa o próprio Value
        const title = item.getDescription?.() || item.getName?.() || val;

        return {
          title: title,
          value: val,
        };
      });
    };

    return Object.freeze(enumObject);
  }
}
